// @ts-nocheck
import t from './shipmentAddress.types';

const initialState = {
  billingAddress: {
    recipient: '',
    attention: '',
    streetLine1: '',
    streetLine2: '',
    city: '',
    state: '',
    postalCode: '',
    country: '',
  },
  shippingAddress: {
    recipient: '',
    attention: '',
    streetLine1: '',
    streetLine2: '',
    city: '',
    state: '',
    postalCode: '',
    country: '',
  },
  shippingAddresses: [],
};

export default function shipmentAddressReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_BILLING_ADDRESS:
      return { ...state, billingAddress: { ...state.billingAddress, ...action.payload } };

    case t.SET_SHIPPING_ADDRESS:
      return { ...state, shippingAddress: { ...action.payload } };

    case t.ADD_SHIPPING_ADDRESS:
      return { ...state, shippingAddresses: [...state.shippingAddresses, action.payload] };

    case t.SET_SHIPPING_ADDRESSES:
      return { ...state, shippingAddresses: action.payload ?? [] };

    case t.UPDATE_SHIPPING_ADDRESS:
      return {
        ...state,
        shippingAddresses: state.shippingAddresses.map((a) =>
          String(a.id) === String(action.payload.id) ? { ...a, ...action.payload } : a
        ),
      };

    case t.REMOVE_SHIPPING_ADDRESS: {
      const filtered = state.shippingAddresses.filter((a) => String(a.id) !== String(action.payload));
      // If the removed address was default, assign default to the first remaining
      const wasDefault = state.shippingAddresses.find((a) => String(a.id) === String(action.payload))?.isDefault;
      const updated = wasDefault && filtered.length > 0
        ? filtered.map((a, i) => i === 0 ? { ...a, isDefault: true } : a)
        : filtered;
      return { ...state, shippingAddresses: updated };
    }

    case t.RESET:
      return initialState;

    default:
      return state;
  }
}
